import { orderBy } from 'lodash';
import Permission from '@/shared/constants/Permission';
import { parseBrands } from '@/shared/converters/brandConverters';
import { parseEntity } from '@/shared/converters/commonConverters';
import { parseOutlets } from '@/shared/converters/outletConverters';
import { SCHEMA as USER_SCHEMA } from '@/shared/converters/userConverters';
import Identity from '../models/Identity';
import { parseGroups } from './targetConverters';
import { parseWorkshopTeams } from './workshopTeamConverters';

const SCHEMA = {
  ...USER_SCHEMA,
  dealerGroupId: 'moboDealerGroupId',
  countryId: 'countryId',
  language: 'languageCode',
  vehicleType: 'objectType',
  roleIds: 'roleIds',
  hasSignature: 'hasSignature',
  mainOutletId: 'mainMoboOutletId',
  outlets: (data: any) => orderBy(parseOutlets(data.accessibleMoboOutlets), 'description'),
  brands: (data: any) => parseBrands(data.activeBrands),
  workshopTeams: (data: any) => parseWorkshopTeams(data.workshopPlanningTeams),
  groups: parseGroups,
  workPreparationRoleId: 'workPreparationRoleId',
  hasDBBCredentials: 'hasDBBCredentials',
};

export function parseIdentity(data: any): Identity | null {
  const identity = parseEntity(data, SCHEMA, Identity);
  // merge functionalPermissions with permissions for now
  if (data.functionalPermissions.canChangeDossierInvoiceStatus) identity?.permissions.push(Permission.CAN_CHANGE_INVOICE_STATUS);
  return identity;
}
